import { apiService } from './api';

export interface Item {
    itemBaseId?: string;
    titulo: string;
    descricao: string;
    tipoBase: "KATRU" | "ENTIDADE";
    questaoBaseId: string;
    acaoIds: number[];
}

// Define Action interface
export interface Action {
    acaoId: string;
    nome: string;
    status: string;
}

// Define pagination parameters
export interface PaginationParams {
    page: number;
    size: number;
    questaoBaseId?: string;
    titulo?: string;
}

// Define paginated response
export interface PaginatedItemResponse {
    content: Item[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
    first: boolean;
    last: boolean;
}

export const itemBaseService = {
    async getItems(params: PaginationParams): Promise<PaginatedItemResponse> {
        try {
            let url = `/item-base?page=${params.page}&size=${params.size}`;

            if (params.questaoBaseId) {
                url += `&questaoBaseId=${params.questaoBaseId}`;
            }

            if (params.titulo) {
                url += `&titulo=${encodeURIComponent(params.titulo)}`;
            }

            const response = await apiService.get<PaginatedItemResponse>(url);
            return response;
        } catch (error) {
            console.error('Error fetching items:', error);
            throw error;
        }
    },

    async getItemById(id: string): Promise<Item> {
        try {
            const response = await apiService.get<Item>(`/item-base/${id}`);
            return response;
        } catch (error) {
            console.error('Error fetching item:', error);
            throw error;
        }
    },

    async createItem(item: Omit<Item, 'itemBaseId'>): Promise<Item> {
        try {
            const response = await apiService.post<Item>('/item-base', item);
            return response;
        } catch (error) {
            console.error('Error creating item:', error);
            throw error;
        }
    },

    async updateItem(id: string, item: Partial<Item>): Promise<Item> {
        try {
            const updateData = {
                titulo: item.titulo,
                descricao: item.descricao,
                tipoBase: item.tipoBase,
                questaoBaseId: item.questaoBaseId,
                acaoIds: item.acaoIds || []
            };

            const response = await apiService.put<Item>(`/item-base/${id}`, updateData);
            return response;
        } catch (error) {
            console.error('Error updating item:', error);
            throw error;
        }
    },

    async deleteItem(id: string): Promise<void> {
        try {
            await apiService.delete(`/item-base/${id}`);
        } catch (error) {
            console.error('Error deleting item:', error);
            throw error;
        }
    }
}; 